import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  happyClientData: [],
};

const happyclientSlice = createSlice({
  name: "happyclient",
  initialState,
  reducers: {
    setHappyClientData(state, action) {
      state.happyClientData = action.payload;
    },
  },
});

export const { setHappyClientData } = happyclientSlice.actions;
export default happyclientSlice.reducer;
